import { HpCommonGroupControlProps } from '../../../types/inputControlTypes';

export function ButtonGroupControl({ controls, id }: HpCommonGroupControlProps): JSX.Element {
  return (
    <div id={`${id}-section`} className="btn-group">
      {controls}
    </div>
  );
}
